import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .5,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M23.2528 25.1253L14.1248 17.1633C13.843 16.9175 13.8138 16.4898 14.0596 16.208C14.0794 16.1854 14.1006 16.1641 14.1232 16.1442L23.2513 8.1321C23.5323 7.88542 23.9601 7.91327 24.2068 8.1943C24.3152 8.31784 24.375 8.47659 24.375 8.64096V24.615C24.375 24.989 24.0719 25.2921 23.6979 25.2921C23.5343 25.2921 23.3762 25.2328 23.2528 25.1253Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.1278 25.1253L5.99981 17.1633C5.71801 16.9175 5.68882 16.4898 5.93463 16.208C5.95439 16.1854 5.97563 16.1641 5.99823 16.1442L15.1263 8.1321C15.4073 7.88542 15.8351 7.91327 16.0818 8.1943C16.1902 8.31784 16.25 8.47659 16.25 8.64096V24.615C16.25 24.989 15.9469 25.2921 15.5729 25.2921C15.4093 25.2921 15.2512 25.2328 15.1278 25.1253Z",
		fill: "white"
	})]
});
export default SvgBackActive;
